if (!customElements.get("popup-overlay")) {
  customElements.define(
    "popup-overlay",
    class PopupOverlay extends ModalDialog {
      constructor() {
        super();
        this.delay = parseInt(this.dataset.delay, 10) * 1000;
        this.id = this.getAttribute("id");
        this.moved = true;
      }

      connectedCallback() {
        if (localStorage.getItem(this.id) !== "dismissed" && !Shopify.designMode) {
          setTimeout(() => {
            this.show();
          }, this.delay);
        }

        return super.connectedCallback();
      }

      show() {
        super.show();
        document.body.classList.remove("overflow-hidden");
        const event = new CustomEvent("popup-overlay:open", {
          detail: {
            id: this.id,
          },
        });
        document.dispatchEvent(event);
      }

      hide() {
        super.hide();
        const event = new CustomEvent("popup-overlay:close", {
          detail: {
            id: this.id,
          },
        });
        document.dispatchEvent(event);

        if (!Shopify.designMode) {
          localStorage.setItem(this.id, "dismissed");
        }
      }
    },
  );
}

// teclan mod for cookies, hide for 60 days
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length);
    }
  }
  return null;
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('popup-overlay').forEach(popup => {
    const cookieName = popup.dataset.popupCookie;

    if (getCookie(cookieName)) {
      popup.remove();
      return;
    }
  });
});
// Close (×) sets cookie ONLY for signup popups
document.addEventListener('click', (e) => {
  const closeBtn = e.target.closest('.modal-dismiss-button');
  if (!closeBtn) return;

  const popup = closeBtn.closest('popup-overlay');
  if (!popup) return;

  const cookieName = popup.dataset.popupCookie;
  if (!cookieName) return; // not a signup popup

  setCookie(cookieName, 'true', 60);
});

// Signup submit sets cookie ONLY for signup popups
document.addEventListener('submit', (e) => {
  const form = e.target.closest('.popup-overlay-newsletter-form');
  if (!form) return;

  const popup = form.closest('popup-overlay');
  if (!popup) return;

  const cookieName = popup.dataset.popupCookie;
  if (!cookieName) return;

  setCookie(cookieName, 'true', 60);
});